import { MdKeyboardArrowLeft } from "react-icons/md";
import { FaRegCircleUser } from "react-icons/fa6";
import React, { useEffect, useState } from "react";
import book1 from "../assets/img/book.png";
import { toDateString } from "../helper/dateHelper";
import { storageApi } from "../storage/storageApi";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

export const HistoryItem = ({
  program_info,
  program_report,
  admin_reply,
  last_modified,

  programTypeList,
  subjectList,
  activityList,
  programNameList,
}) => {

  
  const [reportImages, setReportImages] = useState([]);


  const [ loading, setLoading ] = useState(false);  

  const [ index, setIndex ] = useState(-1);
  const [ slides, setSlides ] = useState([]);
  const loadImages = (src) => {
    return new Promise((res) => {
      const options = {
        headers: {
          authorization: `Bearer ${storageApi.getUserToken()}`,
        },
      };

      fetch(src, options)
        .then((res) => {
          console.log("RRRRRESSS", res);
          return res.blob()
    })
        .then((blob) => {
          res(URL.createObjectURL(blob));
        });
    });
  };

  const getImages = async()=>{
    setLoading(true);
    setReportImages(
      await Promise.all(
        (program_report?.images ?? []).map(
          async (s) => {
            const imageLoadedData = await loadImages(s.image);
            console.log("imageLoadedData", imageLoadedData);
            setLoading(false);
            return {
              ...s,
              localSrc: imageLoadedData,
            };
          },
        ),
      ),
    );
  }

  useEffect(() => {
    getImages();
  }, [])
  if (admin_reply) {
    return (
      <div className="histrory-box-style">
        <div className="flex  flex-row gap-2">
          <span> {toDateString(last_modified, "HH:mm")}</span>-
          <span> {toDateString(last_modified, "jYYYY/jMM/jDD")} </span>
        </div>
        <div className="border-2 border-gray-200 rounded-lg p-4 mt-2">
          <div className="flex justify-between">
            <div className="flex gap-4">
              <MdKeyboardArrowLeft size={24} />
              <span> پیام ناظر </span>
            </div>
            <div className="flex gap-2 text-gray-400">
              <span> ناظر </span>
              <FaRegCircleUser size={20} />
            </div>
          </div>
          <div
            className={`bg-gray-200 p-4 mt-4 rounded-lg ${admin_reply.program_status === "تایید شده" ? "text-green-600" : "text-red-600"} `}
          >
            <div><b>وضعیت: </b>{admin_reply.program_status}</div>
            <div>{admin_reply.description}</div>
            {/*<div className="mt-2">*/}
            {/*  امتیاز*/}
            {/*  <span> ۷ </span>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    );
  }

  console.log(program_report);
  const programType = programNameList.find(
    (c) => c.id === program_info?.onvan_barnameh,
  );

  const activityTitle = activityList.find(
    (c) => c.id === programType?.hoze_faaliat,
  )?.title;

  const programName = programTypeList.find(
    (c) => c.id === programType?.barname_type,
  )?.title;
  console.log("programinfo", program_info);
  const subjects = subjectList
    .filter((c) => program_info.mozooe_tabiyni.includes(c.id))
    .map((c) => c.title)
    .join(" ,");

  if (program_info && program_report) {
    return (
      <div className="histrory-box-style">
        <Lightbox
          index={index}
          slides={slides}
          open={index >= 0}
          plugins={[Zoom]}
          close={() => setIndex(-1)}
        />
        <div className="flex  flex-row gap-2">
          <span> {toDateString(last_modified, "HH:mm")}</span>-
          <span> {toDateString(last_modified, "jYYYY/jMM/jDD")} </span>
        </div>
        <div className="border-2 border-gray-200 rounded-lg p-4 mt-2 space-y-8">
          <div>
            <div className="md:flex justify-between">
              <div className="flex gap-4">
                <MdKeyboardArrowLeft size={24} />
                <span> اطلاعات برنامه پیش بینی شده </span>
              </div>
              {/*<div className="flex gap-2 text-gray-400 mt-4 md:mt-0">*/}
              {/*  <span> علی شعبان </span>*/}
              {/*  <FaRegCircleUser size={20} />*/}
              {/*</div>*/}
            </div>
            <div className="bg-gray-200 p-4 mt-4 rounded-lg text-sm">
              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <span className=" font-semibold"> حوزه فعالیت:</span>
                  <span className=" font-normal"> {activityTitle} </span>
                </div>
                <div>
                  <span className=" font-semibold"> عنوان برنامه:</span>
                  <span className=" font-normal"> {programType?.title}</span>
                </div>
                <div>
                  <span className=" font-semibold"> تاریخ اجرای برنامه:</span>
                  <span className=" font-normal">
                    {toDateString(
                      program_info.implementation_date,
                      "jYYYY/jMM/jDD",
                    )}
                  </span>
                </div>
                <div>
                  <span className=" font-semibold"> نوع برنامه:</span>
                  <span className=" font-normal">{programName}</span>
                </div>
                <div>
                  <span className=" font-semibold"> موضوع تبیینی:</span>
                  <span className=" font-normal">{subjects}</span>
                </div>
                <div>
                  <span className=" font-semibold"> مجری برنامه :</span>
                  <span className=" font-normal">{program_info.presenter}</span>
                </div>
                <div>
                  <span className=" font-semibold"> جزئیات برنامه :</span>
                  <span className=" font-normal">
                    {program_info.description}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="flex justify-between">
              <div className="flex gap-4">
                <MdKeyboardArrowLeft size={24} />
                <span> اطلاعات گزارش</span>
              </div>
              <div className="flex gap-2 text-gray-400">
                {/* <span> علی شعبان </span>
                            <FaRegCircleUser size={20} /> */}
              </div>
            </div>
            <div className="bg-gray-200 p-4 mt-4 rounded-lg text-sm space-y-3">
              <div>
                <div className=" font-semibold">جزئیات (شرح اجرا)</div>
                <p className=" font-normal mt-2 ">
                  {program_report.description}
                </p>
              </div>
              <div>
                <span className=" font-semibold">
                  {" "}
                  تعداد فعالیت های انجام شده:
                </span>
                <span className=" font-normal">
                  {" "}
                  {program_report.executions_number}{" "}
                </span>
              </div>
              {program_report.answer_question?.map((c) => {
                return (
                  <div>
                    <span className=" font-semibold">
                      {" "}
                      {c.question.question}:
                    </span>
                    <span className=" font-normal">{c.answer}</span>
                  </div>
                );
              })}
              {/* images */}
              
              <div className="flex justify-start gap-4">
              { loading && <p className="bg-slate-400 p-2 h-10 text-white rounded-2xl">در حال دانلود عکس‌ها لطفا منتظر بمانید.</p>}

                {reportImages?.map((c, j) => {
                  console.log("Ccccclccc",c.localSrc);
                  return (
                    <div className="p-2 bg-white hover:bg-gray-100 border-2  border-dashed border-gray-300 rounded-xl cursor-pointer "
                    onClick={ 
                      () => {
                      const newSlides = [];
                      reportImages.map((i) => {
                        newSlides.push({
                          type: "image",
                          src: i.localSrc,
                        })
                      })
                      setSlides(newSlides);
                      setIndex(j);
                    }}>
                      <img  src={c.localSrc || c.image} className=" w-20" />
                    </div>
                  );
                })}
              </div>

            </div>
          </div>
        </div>
        
      </div>
    );
  }

  if (program_info) {
    return (
      <div className="histrory-box-style">
        <div className="flex  flex-row gap-2">
          <span> {toDateString(last_modified, "HH:mm")}</span>-
          <span> {toDateString(last_modified, "jYYYY/jMM/jDD")} </span>
        </div>
        <div className="border-2 border-gray-200 rounded-lg p-4 mt-2 space-y-8">
          <div>
            <div className="md:flex justify-between">
              <div className="flex gap-4">
                <MdKeyboardArrowLeft size={24} />
                <span> اطلاعات برنامه پیش بینی شده </span>
              </div>
              {/*<div className="flex gap-2 text-gray-400 mt-4 md:mt-0">*/}
              {/*  <span> علی شعبان </span>*/}
              {/*  <FaRegCircleUser size={20} />*/}
              {/*</div>*/}
            </div>
            <div className="bg-gray-200 p-4 mt-4 rounded-lg text-sm">
              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <span className=" font-semibold"> حوزه فعالیت:</span>
                  <span className=" font-normal"> {activityTitle} </span>
                </div>
                <div>
                  <span className=" font-semibold"> عنوان برنامه:</span>
                  <span className=" font-normal"> {programType?.title}</span>
                </div>
                <div>
                  <span className=" font-semibold"> تاریخ اجرای برنامه:</span>
                  <span className=" font-normal">
                    {toDateString(
                      program_info.implementation_date,
                      "jYYYY/jMM/jDD",
                    )}
                  </span>
                </div>
                <div>
                  <span className=" font-semibold"> نوع برنامه:</span>
                  <span className=" font-normal">{programName}</span>
                </div>
                <div>
                  <span className=" font-semibold"> موضوع تبیینی:</span>
                  <span className=" font-normal">{subjects}</span>
                </div>
                <div>
                  <span className=" font-semibold"> مجری برنامه :</span>
                  <span className=" font-normal">{program_info.presenter}</span>
                </div>
                <div>
                  <span className=" font-semibold"> جزئیات برنامه :</span>
                  <span className=" font-normal">
                    {program_info.description}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (program_report) {
    return (
      <div className="histrory-box-style">
        <div className="flex  flex-row gap-2">
          <span> {toDateString(last_modified, "HH:mm")}</span>-
          <span> {toDateString(last_modified, "jYYYY/jMM/jDD")} </span>
        </div>
        <div className="border-2 border-gray-200 rounded-lg p-4 mt-2 space-y-8">
          <div>
            <div className="md:flex justify-between">
              <div className="flex gap-4">
                <MdKeyboardArrowLeft size={24} />
                <span> اطلاعات برنامه پیش بینی شده </span>
              </div>
              {/*<div className="flex gap-2 text-gray-400 md:mt-0 mt-4 ">*/}
              {/*  <span> علی شعبان </span>*/}
              {/*  <FaRegCircleUser size={20} />*/}
              {/*</div>*/}
            </div>
          </div>
          <div>
            <div className="flex justify-between">
              <div className="flex gap-4">
                <MdKeyboardArrowLeft size={24} />
                <span> اطلاعات گزارش</span>
              </div>
              <div className="flex gap-2 text-gray-400">
                {/* <span> علی شعبان </span>
                            <FaRegCircleUser size={20} /> */}
              </div>
            </div>
            <div className="bg-gray-200 p-4 mt-4 rounded-lg text-sm space-y-3">
              <div>
                <div className=" font-semibold">جزئیات (شرح اجرا)</div>
                <p className=" font-normal mt-2 ">
                  {program_report.description}
                </p>
              </div>
              <div>
                <span className=" font-semibold">
                  {" "}
                  تعداد فعالیت های انجام شده:
                </span>
                <span className=" font-normal">
                  {" "}
                  {program_report.executions_number}{" "}
                </span>
              </div>
              {program_report.answer_question?.map((c) => {
                return (
                  <div>
                    <span className=" font-semibold">
                      {" "}
                      {c.question.question}:
                    </span>
                    <span className=" font-normal">{c.answer}</span>
                  </div>
                );
              })}
              {/* images */}
              <div className="flex justify-start gap-4">
                {program_report.images?.map((c) => {
                  return (
                    <div className="p-2 bg-white hover:bg-gray-100 border-2  border-dashed border-gray-300 rounded-xl cursor-pointer"
                    onClick={ 
                      () => {
                      const newSlides = [];
                      program_report.images?.map((i) => {
                        newSlides.push({
                          type: "image",
                          src: i.localSrc,
                        })
                      })
                      setSlides(newSlides);
                      setIndex(j);
                    }}>
                      <img src={c.localSrc || c.image} className=" w-20" />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
